import { useStudioStore, PreviewDevice } from '@/store/useStudioStore';
import { cn } from '@/lib/utils';
import { trackStudioEvent } from '@/lib/studioTracking';

/** 设备预览切换组件 */
export const StudioDeviceSwitcher = () => {
  const { previewDevice, setPreviewDevice, isBuilding, iframeUrl, generatedHtml } =
    useStudioStore();

  const previewDevices: { id: PreviewDevice; icon: string; title: string }[] = [
    { id: 'desktop', icon: 'fa fa-desktop', title: 'Desktop' },
    { id: 'tablet', icon: 'fa fa-tablet-screen-button', title: 'Tablet' },
    { id: 'mobile', icon: 'fa fa-mobile-screen', title: 'Mobile' },
  ];

  return (
    <div className="studio-device-switcher flex gap-[2px] rounded-[8px] border border-black/5 bg-[#f7f7fc] p-[3px] shadow-sm">
      {previewDevices.map((d) => (
        <button
          key={d.id}
          title={d.title}
          disabled={isBuilding ?? false}
          onClick={() => {
            if (previewDevice === d.id) return;

            trackStudioEvent('studio_preview_device_change', {
              fromDevice: previewDevice,
              toDevice: d.id,
              isBuilding: Boolean(isBuilding),
              hasPreview: Boolean(iframeUrl || generatedHtml),
            });
            setPreviewDevice(d.id);
          }}
          className={cn(
            'flex h-[26px] w-[28px] cursor-pointer items-center justify-center rounded-[5px] border-none bg-transparent text-[12px] transition-all disabled:cursor-default disabled:opacity-40',
            previewDevice === d.id
              ? 'text-foreground bg-white shadow-[0_1px_3px_rgba(0,0,0,0.07)]'
              : 'text-muted-foreground/40 hover:text-foreground',
          )}
        >
          <i className={d.icon} />
        </button>
      ))}
    </div>
  );
};
